import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { BorrowerLoansStore } from '../stores/borrowerLoansStore';

export const useBorrowerLoansStore = () =>
  useContext<{
    borrowerLoansStore: BorrowerLoansStore;
  }>(StoreContext);
